export const FETCH_PORTFOLIO_DETAILS = 'src/Corporate/my-portfolio/action/Fetch_Portfolio_Details';
export const FETCH_PORTFOLIO_DETAILS_SUCCESS = 'src/Corporate/my-portfolio/action/Fetch_Portfolio_Details_Success';
export const FETCH_PORTFOLIO_DETAILS_FAILURE = 'src/Corporate/my-portfolio/action/Fetch_Portfolio_Details_Failure';
export const fetchPortfolioDetails = (data) => {
    return {
        type: FETCH_PORTFOLIO_DETAILS,
        data
    }
}
export const fetchPortfolioDetailsSuccess = (data) => {
    return {
        type: FETCH_PORTFOLIO_DETAILS_SUCCESS,
        data
    }
}
export const fetchPortfolioDetailsFailure = (data) => {
    return {
        type: FETCH_PORTFOLIO_DETAILS_FAILURE,
        data
    }
}

export const SEARCH_PORTFOLIO = 'src/Corporate/my-portfolio/action/Search_Portfolio';
export const SEARCH_PORTFOLIO_SUCCESS = 'src/Corporate/my-portfolio/action/Search_Portfolio_Success';
export const SEARCH_PORTFOLIO_FAILURE = 'src/Corporate/my-portfolio/action/Search_Portfolio_Failure';
export const searchPortfolio = (data) => {
    return {
        type: SEARCH_PORTFOLIO,
        data
    }
}
export const searchPortfolioSuccess = (data) => {
    return {
        type: SEARCH_PORTFOLIO_SUCCESS,
        data
    }
}
export const searchPortfolioFailure = (data) => {
    return {
        type: SEARCH_PORTFOLIO_FAILURE,
        data
    }
}

export const FETCH_RISK_LEVELS = 'src/Components/my-portfolio/action/Fetch_Risk_Level'
export const FETCH_RISK_LEVELS_SUCCESS = 'src/Components/my-portfolio/action/Fetch_Risk_Level_Success'
export const FETCH_RISK_LEVELS_FAILURE = 'src/Components/my-portfolio/action/Fetch_Risk_Level_Failure'
export const fetchRiskLevels = () => {
    return {
        type: FETCH_RISK_LEVELS
    }
}
export const fetchRiskLevelsSuccess = (data) => {
    return {
        type: FETCH_RISK_LEVELS_SUCCESS,
        data
    }
}
export const fetchRiskLevelsFailure = (data) => {
    return {
        type: FETCH_RISK_LEVELS_FAILURE,
        data
    }
}

export const FETCH_LEGALCONSTITUTION = 'src/Corporate/my-portfolio/action/Fetch_Legal_Constituation';
export const FETCH_LEGALCONSTITUTION_SUCCESS = 'src/Corporate/my-portfolio/action/Fetch_Legal_Constituation_Success';
export const FETCH_LEGALCONSTITUTION_FAILURE = 'src/Corporate/my-portfolio/action/Fetch_Legal_Constituation_Failure';

export const fetchLegalConstitutionFilter = (data) => {
    return {
        type: FETCH_LEGALCONSTITUTION,
        data
    }
}
export const fetchLegalConstitutionFilterSuccess = (data) => {
    return {
        type: FETCH_LEGALCONSTITUTION_SUCCESS,
        data
    }
}
export const fetchLegalConstitutionFilterFailure = (data) => {
    return {
        type: FETCH_LEGALCONSTITUTION_FAILURE,
        data
    }
}

export const FETCH_BUSINESS_SEGMENT = 'src/Corporate/my-portfolio/action/Fetch_Business_Segment';
export const FETCH_BUSINESS_SEGMENT_SUCCESS = 'src/Corporate/my-portfolio/action/Fetch_Business_Segment_Success';
export const FETCH_BUSINESS_SEGMENT_FAILURE = 'src/Corporate/my-portfolio/action/Fetch_Business_Segment_Failure';

export const fetchBusinessSegmentFilter = (data) => {
    return {
        type: FETCH_BUSINESS_SEGMENT,
        data
    }
}
export const fetchBusinessSegmentFilterSuccess = (data) => {
    return {
        type: FETCH_BUSINESS_SEGMENT_SUCCESS,
        data
    }
}
export const fetchBusinessSegmentFilterFailure = (data) => {
    return {
        type: FETCH_BUSINESS_SEGMENT_FAILURE,
        data
    }
}

export const FETCH_CASE_STATUS = 'src/Corporate/my-portfolio/action/Fetch_Case_Status';
export const FETCH_CASE_STATUS_SUCCESS = 'src/Corporate/my-portfolio/action/Fetch_Case_Status_Success';
export const FETCH_CASE_STATUS_FAILURE = 'src/Corporate/my-portfolio/action/Fetch_Case_Status_Failure';

export const fetchCaseStatusFilter = (data) => {
    return {
        type: FETCH_CASE_STATUS,
        data
    }
}
export const fetchCaseStatusFilterSuccess = (data) => {
    return {
        type: FETCH_CASE_STATUS_SUCCESS,
        data
    }
}
export const fetchCaseStatusFilterFailure = (data) => {
    return {
        type: FETCH_CASE_STATUS_FAILURE,
        data
    }
}
export const FETCH_RISK_TREND = 'src/Corporate/my-portfolio/action/Fetch_Risk_Trend';
export const FETCH_RISK_TREND_SUCCESS = 'src/Corporate/my-portfolio/action/Fetch_Risk_Trend_Success';
export const FETCH_RISK_TREND_FAILURE = 'src/Corporate/my-portfolio/action/Fetch_Risk_Trend_Failure';

export const fetchRiskScoreTrendFilter = (data) => {
    return {
        type: FETCH_RISK_TREND,
        data
    }
}
export const fetchRiskScoreTrendFilterSuccess = (data) => {
    return {
        type: FETCH_RISK_TREND_SUCCESS,
        data
    }
}
export const fetchRiskScoreTrendFilterFailure = (data) => {
    return {
        type: FETCH_RISK_TREND_FAILURE,
        data
    }
}

export const FETCH_PRODUCT_NAME_FILTER_LIST = 'src/Corporate/my-portfolio/action/Fetch_Product_Name_Filter_List';
export const FETCH_PRODUCT_NAME_FILTER_LIST_SUCCESS = 'src/Corporate/my-portfolio/action/Fetch_Product_Name_Filter_List_Success';
export const FETCH_PRODUCT_NAME_FILTER_LIST_FAILURE = 'src/Corporate/my-portfolio/action/Fetch_Product_Name_Filter_List_Failure';

export const fetchProductNameFilterList = (data) => {
    return {
        type: FETCH_PRODUCT_NAME_FILTER_LIST,
        data
    }
}
export const fetchProductNameFilterListSuccess = (data) => {
    return {
        type: FETCH_PRODUCT_NAME_FILTER_LIST_SUCCESS,
        data
    }
}
export const fetchProductNameFilterListFailure = (data) => {
    return {
        type: FETCH_PRODUCT_NAME_FILTER_LIST_FAILURE,
        data
    }
}

export const FETCH_PRODUCT_TYPE_DETAILS = 'src/Corporate/my-portfolio//action/Fetch_Product_Type_Details';
export const FETCH_PRODUCT_TYPE_DETAILS_SUCCESS = 'src/Corporate/my-portfolio//action/Fetch_Product_Type_Details_Success';
export const FETCH_PRODUCT_TYPE_DETAILS_FAILURE = 'src/Corporate/my-portfolio//action/Fetch_Product_Type_Details_Failure';

export const fetchProductTypeDetails = () => {
    return {
        type: FETCH_PRODUCT_TYPE_DETAILS
    }
}

export const fetchProductTypeDetailsSuccess = (data) => {
    return {
        type: FETCH_PRODUCT_TYPE_DETAILS_SUCCESS,
        data
    }
}

export const fetchProductTypeDetailsFailure = (data) => {
    return {
        type: FETCH_PRODUCT_TYPE_DETAILS_FAILURE,
        data
    }
}

export const PORTFOLIO_APPLIED_FILTERS = 'src/Corporate/my-portfolio//action/Portfolio_Applied_Filters';

export const setPortfolioFilters = (data) => {
    return {
        type: PORTFOLIO_APPLIED_FILTERS,
        data
    }
}

export const FETCH_CUG_CORPORATE_DATA = 'src/Corporate/my-portfolio//action/Fetch_CUG_Corporate_Data';
export const FETCH_CUG_CORPORATE_DATA_SUCCESS = 'src/Corporate/my-portfolio//action/Fetch_CUG_Corporate_Data_Success';
export const FETCH_CUG_CORPORATE_DATA_FAILURE = 'src/Corporate/my-portfolio//action/Fetch_CUG_Corporate_Data_Failure';
export const fetchCugCorpData = (data) => {
    return {
        type: FETCH_CUG_CORPORATE_DATA,
        data
    }
}

export const fetchCugCorpDataSuccess = (data) => {
    return {
        type: FETCH_CUG_CORPORATE_DATA_SUCCESS,
        data
    }
}

export const fetchCugCorpDataFailure = (data) => {
    return {
        type: FETCH_CUG_CORPORATE_DATA_FAILURE,
        data
    }
}

export const FETCH_CASE_TYPE = 'src/Components/my-portfolio/action/Fetch_Case_Type'
export const FETCH_CASE_TYPE_SUCCESS = 'src/Components/my-portfolio/action/Fetch_Case_Type_Success'
export const FETCH_CASE_TYPE_FAILURE = 'src/Components/my-portfolio/action/Fetch_Case_Type_Failure'
export const fetchCaseType = () => {
    return {
        type: FETCH_CASE_TYPE
    }
}
export const fetchCaseTypeSuccess = (data) => {
    return {
        type: FETCH_CASE_TYPE_SUCCESS,
        data
    }
}
export const fetchCaseTypeFailure = (data) => {
    return {
        type: FETCH_CASE_TYPE_FAILURE,
        data
    }
}

export const GET_SELECTED_COMPANY_NAME ='src/Components/my-portfolio/action/getSelectedCompanyName';
export const getSelectedCompanyName = (data) => {
    return {
        type: GET_SELECTED_COMPANY_NAME,
        data
    }
}